import {Tenant} from "./Tenant";
import { DashboardConfig } from "./Dashboard";

export interface UserDevice {
    id: string;
    created: string;
    user_agent: string;
    ip_address: string;
}

export interface UserMfaSetup {
    mfa_qr: string;
}

export class User {
    id!: string;
    name!: string;
    email!: string;
    activated!: boolean;
    region!: string;
    phone!: string;
    accounts!: string[];
    level?: number;
    password?: string;
    mfa_active?: boolean;
    mfa_methods?: string[];
    devices?: UserDevice[];
    dashboard?: DashboardConfig;


    public AddTenantToUser(tenant: Tenant) {
        this.accounts = [...this.accounts.filter(account => account !== tenant.id), tenant.id]
    }
    
    public RemoveTenantFromUser(tenant: Tenant) {
        this.accounts = this.accounts.filter(account => account !== tenant.id)
    }

}
